import { render, staticRenderFns } from "./KpiTargets.vue?vue&type=template&id=63f12f7f&"
import script from "./KpiTargets.vue?vue&type=script&lang=js&"
export * from "./KpiTargets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports